import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import {
  BACKGROUND_GRAY, BLUE_40,
  RED_50,
  SUBMIT_BUTTON_STYLES,
} from "../../../constants/css.constants";
import useClient from "../../../hooks/useClient";
import { FORECAST_URI } from "../ShipmentMonthTables/ShipmentMonthTables.constants";
import {
  ForecastContext,
  ForecastResponse,
} from "../../../contexts/ForecastContext";
import useEditRights from "../../../hooks/useEditRights";
import useSubmissionDate from "../../../hooks/useSubmissionDate";
import Modal from "../../../components/Modal/Modal";
import { Check } from "@mui/icons-material";
import {IGNORE_SUBMISSION_WINDOW} from "../../../constants/app.constants";

const RevertButton = ({
  queryParams,
  setError,
  tabRef,
}: {
  queryParams: string;
  setError: (text: string) => void;
  tabRef: any;
}) => {
  const { setOriginalForecast, setStatus } = useContext(ForecastContext);
  const { reset } = useClient();
  const { canEdit } = useEditRights();
  const { outsideSubmissionDate } = useSubmissionDate();
  const disabled = (IGNORE_SUBMISSION_WINDOW) ? false : outsideSubmissionDate || !canEdit;
  const [success, setSuccess] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const onClick = async () => {
    const resetData = await reset<ForecastResponse>(
      `${FORECAST_URI}${queryParams}`,
      setError,
    );
    if (resetData) {
      tabRef.current.style.backgroundColor=BLUE_40;
      setOriginalForecast(resetData);
      setStatus(resetData["status"]);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
      setIsOpen(false);
    }
  };
  return (
    <>
      <Modal
        handleYes={onClick}
        handleClose={() => setIsOpen(false)}
        text={"Are you sure you want to revert?"}
        isOpen={isOpen}
        disabled={disabled}
      />
      <Button
        style={SUBMIT_BUTTON_STYLES(disabled ? BACKGROUND_GRAY : RED_50)}
        variant="contained"
        onClick={() => setIsOpen(true)}
        size="large"
        disabled={disabled}
      >
        <span style={{ marginRight: "5px" }}>Revert</span>
        {success && <Check color={"primary"} />}
      </Button>
    </>
  );
};

export default RevertButton;
